import styles from './PostTitle.module.css'
import stylePost from 'shared-components/styles/post.module.css'
import clsx from 'clsx'
import { BasicStyledComponent } from 'shared-definitions/types'
import { ReactNode } from 'react'

interface PostTitleProps extends BasicStyledComponent {
  title: string
  subtitle: string | ReactNode
}

const PostTitle: React.VFC<PostTitleProps> = ({ className, title, subtitle }) => (
  <div className={className}>
    <h1 className={stylePost.pageTitle}>{title}</h1>
    {subtitle ? (
      <div
        className={clsx(styles.subtitle, {
          [stylePost.pageSubTitle]: typeof subtitle === 'string',
        })}
      >
        {subtitle}
      </div>
    ) : null}
  </div>
)

export default PostTitle
